<template>
  <v-app>
    <div :class="{ 'dark-mode-layout': isDarkMode, 'container': true }">
      <Sidebar :isDarkMode="isDarkMode" @dark-mode-changed="updateDarkMode" />

      <v-main>
        <router-view :isDarkMode="isDarkMode" />

        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" :timeout="3000" color="error">
          Platnost bezpečnostního tokenu vypršela, přihlašte se prosím znovu.
          <template #action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">Zavřít</v-btn>
          </template>
        </v-snackbar>

        <!-- Footer -->
        <footer :class="{ 'footer': isDarkMode }">
          <p :style="{ color: isDarkMode ? '#fff' : '#000' }">support@benatky.app</p>
          <p>Verze 1.0.1</p>
        </footer>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import Sidebar from './views/Admin/components/sidebar.vue';
import { mdiHome } from '@mdi/js';
import userService from './views/Services/UserService';

export default {
  components: {
    Sidebar,
    mdiHome
  },

  data() {
    return {
      isDarkMode: JSON.parse(localStorage.getItem('isDarkMode')) || false,
      snackbar: false,
    };
  },

  provide() {
    return {
      isDarkMode: () => this.isDarkMode
    };
  },

  beforeCreate() {
    if (!userService.checkUserLogin()) {
      return;
    }
  },

  mounted() {
    this.checkTokenValidity();
  },

  methods: {
    updateDarkMode(isDarkMode) {
      this.isDarkMode = isDarkMode;
      localStorage.setItem('isDarkMode', JSON.stringify(isDarkMode));
    },

    checkTokenValidity() {
      const exp = localStorage.getItem('jwt_exp');
      if (exp && Date.now() >= exp * 1000) {
        this.showSnackbar();
        this.logout();
      }
    },

    showSnackbar() {
      this.snackbar = true;
    },

    logout() {
      localStorage.clear();
      localStorage.setItem(
          'logoutMessage',
          'Z bezpečnostních důvodů jste byl odhlášen, můžete se znova přihlásit.'
      );
      window.location.href = '/prihlaseni';
    }
  }
};
</script>

<style scoped>
.dark-mode-layout {
  background-color: #333;
  color: #fff;
  min-width: 100%;
  min-height: 100%;
}

.dark-mode {
  background-color: #333;
  color: #fff;
  min-width: 100%;
  min-height: 100vh;
}

.app-container {
  min-height: 100vh;
  display: flex;
}

footer {
  text-align: right;
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 20px;
}

@media (max-width: 768px) {
  footer {
    position: relative;
    text-align: center;
    width: 100%;
  }
}
</style>
